import type { FeatureFlagConfig } from '@/feature-flags/types';
import { EnvironmentNameEnum, getEnvironment } from '@/config/environment';

function getFliptUrl(): string {
  const env = getEnvironment();

  const fliptUrls: Record<string, string> = {
    production: process.env.NEXT_PUBLIC_FLIPT_URL || 'https://flipt.medprev.app',
    homolog: process.env.NEXT_PUBLIC_FLIPT_URL || 'https://flipt-hml.medprev.app',
    test: process.env.NEXT_PUBLIC_FLIPT_URL || 'https://flipt-test.medprev.app',
    dev: process.env.NEXT_PUBLIC_FLIPT_URL || 'https://flipt-test.medprev.app',
    local: process.env.NEXT_PUBLIC_FLIPT_URL || 'https://flipt-test.medprev.app',
  };

  return fliptUrls[env.name] || fliptUrls.production;
}

function getFliptToken(): string | undefined {
  const env = getEnvironment();

  const tokens: Record<string, string | undefined> = {
    production: process.env.NEXT_PUBLIC_FLIPT_API_TOKEN,
    homolog: process.env.NEXT_PUBLIC_FLIPT_API_TOKEN_HML,
    test: process.env.NEXT_PUBLIC_FLIPT_API_TOKEN_TEST,
    dev: process.env.NEXT_PUBLIC_FLIPT_API_TOKEN_TEST,
    local: process.env.NEXT_PUBLIC_FLIPT_API_TOKEN_TEST,
  };

  return tokens[env.name] || process.env.NEXT_PUBLIC_FLIPT_API_TOKEN;
}

export function getFeatureFlagConfig(): FeatureFlagConfig {
  const env = getEnvironment();

  return {
    fliptUrl: getFliptUrl(),
    apiToken: getFliptToken(),
    evaluationTimeout: 3000,
    debug: env.name === EnvironmentNameEnum.LOCAL || env.name === EnvironmentNameEnum.DEV,
  };
}
